import React from "react";

function formatTime(sec) {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export default function GameHUD({ elapsedSeconds, score, variant = "inline", backButton = null }) {
  const rootClass =
    variant === "map"
      ? "unhealthy-hud unhealthy-hud--map"
      : variant === "stage"
        ? "unhealthy-hud unhealthy-hud--stage"
        : "unhealthy-hud";
  return (
    <div className={rootClass}>
      {variant === "stage" ? (
        <>
          <div className="unhealthy-hud-stage-left">
            {backButton}
            <div className="unhealthy-pill">Time: {formatTime(elapsedSeconds)}</div>
          </div>
          <div className="unhealthy-pill">Score: {score}</div>
        </>
      ) : (
        <>
          <div className="unhealthy-pill">Time: {formatTime(elapsedSeconds)}</div>
          <div className="unhealthy-pill">Score: {score}</div>
        </>
      )}
    </div>
  );
}

